import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" className={props.className}>
    <g fill="none" fillRule="evenodd" stroke="#B5B4B8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(1 1)">
      <circle cx="8" cy="7" r="2.5" />
      <path d="M2.691 10.75L.53 14.35a.757.757 0 0 0 .785 1.135L8 14.271l6.686 1.216a.757.757 0 0 0 .785-1.135l-2.161-3.6" />
      <circle cx="8" cy="7" r="6.5" />
    </g>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
